import moment from 'moment-timezone';

export type CalendarTabView = 'slotsWeek' | 'slotsDay';

export interface DatesRange {
  from: moment.Moment;
  to: moment.Moment;
}

export interface CalendarDatesChanged {
  current: Date;
  start: Date;
  end: Date;
  formattedRange: string;
}

export type InlayType = 'track' | 'playlist';

export interface Inlay {
  type: InlayType;
  interval: number;
  id: number;
  playlistTracks?: number;
}

export interface SlotRepeat {
  repeatEnd: moment.Moment;
  repeatCount: number;
  repeatInterval: number;
  repeatDays: string;
}

export interface SlotOccurrence {
  id: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface Slot {
  id?: number;
  program?: SlotProgram['id'];
  playlist?: SlotPlaylist['id'];
  kind: SlotKind;
  playType: SlotPlayType;
  start: moment.Moment;
  end: moment.Moment;
  startHour?: moment.Moment;
  endHour?: moment.Moment;
  fixedTime: boolean;
  tolerance?: number;
  repeat?: SlotRepeat;
  inlay?: Inlay;
  occurrences: SlotOccurrence[];
}

export interface SlotProgram {
  id: number;
  name: string;
  color: string;
}

export interface SlotPlaylist {
  id: number;
  name: string;
  color: string;
  type: 'manual' | 'dynamic';
}

export enum SlotKind {
  program = 'program',
  playlist = 'playlist',
}

export type SlotPlayType = 'sequential' | 'random';
